import { render, staticRenderFns } from "./StatCallsOperatore.vue?vue&type=template&id=681e6e60&"
import script from "./StatCallsOperatore.vue?vue&type=script&lang=ts&"
export * from "./StatCallsOperatore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports